/* src/app/ai-sourcing/ai-sourcing-landingpage/ai-sourcing-landingpage.component.scss */
.btn-trms-medium {
  border-radius: 8px;
  font-size: 17px;
  padding: 13px 25px;
  height: auto;
}
.ai-sourcing-hero-banner {
  background:
    linear-gradient(
      280deg,
      #EDF8FF 74.72%,
      #8BDAE5 99.23%);
  padding: 26px;
  border-radius: 8px;
  display: flex;
}
.ai-sourcing-hero-banner .left-img {
  width: 180px;
}
.ai-sourcing-hero-banner .left-img img {
  max-width: 100%;
  height: auto;
}
.ai-sourcing-hero-banner .hero-content {
  width: calc(100% - 250px);
  margin-left: 50px;
}
.ai-sourcing-hero-banner .hero-content .btn-intro {
  width: 100px;
  height: 22px;
  border-radius: 4px;
  background-color: #FFED27;
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 34px;
  border: 0;
  outline: none;
}
.ai-sourcing-hero-banner .hero-content h1 {
  font-size: 48px;
  line-height: 0.75;
  color: #2E93A1;
  font-weight: 600;
  margin-bottom: 20px;
}
.ai-sourcing-hero-banner .hero-content p.f-16 {
  color: #2E93A1;
  line-height: 1;
}
.ai-sourcing-hero-banner .hero-content p.f-16 span {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.seperator {
  margin-top: 16px;
  margin-bottom: 16px;
  border-top: 1px solid #D9D9D9;
}
.ai-sourcing-feature-list {
  display: flex;
  flex-wrap: wrap;
}
.ai-sourcing-feature-list .ai-sourcing-feature {
  width: calc(50% - 16px);
  display: flex;
  margin: 0 16px 16px 0;
  border: 1px solid;
  border-image-source:
    linear-gradient(
      24.44deg,
      #CDF8FF 15.52%,
      #8FEFFD 84.48%);
  border-image-slice: 1;
  border-radius: 8px;
  padding: 11px 16px;
  background-color: #EDF9FF;
  position: relative;
  overflow: hidden;
}
.ai-sourcing-feature-list .ai-sourcing-feature:nth-child(even) {
  margin: 0 0px 16px 0;
  width: calc(50% - 0px);
}
.ai-sourcing-feature-list .ai-sourcing-feature::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background:
    linear-gradient(
      24.44deg,
      #CDF8FF 15.52%,
      #8FEFFD 84.48%);
  z-index: -1;
  border-radius: 10px;
}
.ai-sourcing-feature-list .ai-sourcing-feature .feature-icon {
  color: #484b59;
  width: 32px;
  margin-right: 8px;
  border-right: 1px solid #484b59;
}
.ai-sourcing-feature-list .ai-sourcing-feature .feature-content {
  font-size: 16px;
  font-weight: 500;
  color: #484b59;
  line-height: 1;
  letter-spacing: 0.1px;
}
.bottom-gradient {
  background:
    linear-gradient(
      360deg,
      #EFF9FB 0%,
      #FFFFFF 100%);
  height: 168px;
}
.blue-gradient {
  background:
    linear-gradient(
      90deg,
      #005499 -106.32%,
      #0C86E9 46.9%,
      #005499 142.96%);
}
.btn-ai-sourcing-white {
  padding: 13px 38px;
  border: 1px solid #F2F2F2;
  color: #fff;
  border-radius: 8px;
  font-size: 18px;
  line-height: 1;
  background-color: #F2F2F2;
  min-width: 117px;
  outline: none;
  color: #969696;
  font-weight: 600;
}
.btn-ai-joinwaitlist {
  padding: 13px 38px;
  border: 1px solid #E86188;
  color: #fff;
  border-radius: 8px;
  font-size: 18px;
  line-height: 1;
  background-color: #E86188;
  min-width: 117px;
  outline: none;
  color: #ffffff;
  font-weight: 600;
}
.gen-ai-text {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ai-sourcing-steps {
  display: flex;
  flex-wrap: wrap;
}
.ai-sourcing-steps .ai-sourcing-step-card {
  width: calc(20% - 13px);
  margin: 0 13px 13px 0;
  padding: 16px 26px;
  border-radius: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.0901960784);
}
.ai-sourcing-steps .ai-sourcing-step-card .step-card-header {
  margin-bottom: 8px;
}
.ai-sourcing-steps .ai-sourcing-step-card .step-card-header .icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #2E93A1;
  padding: 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: #2E93A1;
}
.ai-sourcing-steps .ai-sourcing-step-card .step-card-header .text-step {
  font-size: 10px;
  color: #969696;
  letter-spacing: 0.1px;
}
.ai-sourcing-steps .ai-sourcing-step-card .step-card-content {
  display: block;
  color: #484b59;
}
.ai-sourcing-steps .ai-sourcing-step-card .step-card-content p.f-14 {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 12px;
}
.ai-sourcing-steps .ai-sourcing-step-card .step-card-content p.f-12 {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 0px;
}
.ai-sourcing-steps .ai-sourcing-step-card:last-child {
  margin-right: 0px;
  width: calc(20% - 0px);
}
.ai-header {
  background-image: url("./media/ai-sourcing-bg-6FJCZCO2.png");
  background-size: cover;
  background-position: left top;
  background-repeat: no-repeat;
  margin: -15px;
  margin-left: -16px;
  margin-bottom: 0;
  height: 390px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ai-header .hero-content {
  margin: 50px 16px;
}
.ai-header .hero-content .logo {
  width: 70px;
  height: 70px;
  margin: 0 auto;
}
.ai-header .hero-content h1 {
  font-size: 42px;
  line-height: 1.5;
  font-weight: 600;
  background:
    linear-gradient(
      90deg,
      #57E7FB 0%,
      #ED1EAF 100%);
  color: transparent;
  background-clip: text;
}
.ai-header .hero-content h2 {
  font-size: 24px;
  line-height: 1.3;
  color: #fff;
  font-weight: normal;
  margin-bottom: 15px;
  text-align: center;
}
.ai-header .hero-content div {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.ai-header .hero-content div span {
  font-size: 14px;
  color: #ffffff;
}
.ai-header .hero-content div i {
  font-size: 5px;
  color: #57E7FB;
  margin: 0 15px;
}
.ai-header .hero-content p {
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 20px;
}
.ai-page-body {
  background:
    linear-gradient(
      180deg,
      #FFFFFF 81.45%,
      #C9EFF4 100%);
  padding: 35px;
  margin-left: -15px;
  margin-right: -15px;
}
.ai-page-body .ai-sourcing-diff-card {
  position: relative;
  text-align: center;
  width: 25%;
  padding: 0 15px;
}
.ai-page-body .ai-sourcing-diff-card i {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
}
.ai-page-body .ai-sourcing-diff-card p {
  font-size: 16px;
  font-weight: 500;
  color: #484B59;
  text-align: center;
  margin-bottom: 10px;
}
.ai-page-body .ai-sourcing-diff-card span {
  font-size: 12px;
  color: #969696;
  line-height: 1.4;
  text-align: center;
}
.ai-page-body .ai-sourcing-diff-card .fa-bullseye-arrow {
  color: #F53737;
}
.ai-page-body .ai-sourcing-diff-card .fa-star {
  color: #D2FF0B;
}
.ai-page-body .ai-sourcing-diff-card .fa-globe-pointer {
  color: #0B91FF;
}
.ai-page-body .ai-sourcing-diff-card .fa-user-check {
  color: #37F544;
}
.ai-page-body .ai-sourcing-diff-card::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 55px;
  background-color: #969696;
  right: 0;
  top: 25px;
  display: block;
}
.ai-page-body .ai-sourcing-diff-card:last-child::after {
  display: none;
}
.ai-page-body .easy-step-card {
  cursor: pointer;
  width: calc(25% - 15px);
  border-radius: 8px;
  background-color: rgba(188, 255, 226, 0.3019607843);
  border: 1px solid;
  border-image-source:
    linear-gradient(
      180deg,
      #2E93A1 0%,
      #B3E8EF 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  margin-right: 20px;
  height: 200px;
}
.ai-page-body .easy-step-card:last-child {
  margin-right: 0;
}
.ai-page-body .easy-step-card i {
  color: #0C5B66;
  font-size: 20px;
  margin-bottom: 10px;
}
.ai-page-body .easy-step-card .steps {
  font-size: 14px;
  color: #0C5B66;
  margin-bottom: 10px;
}
.ai-page-body .easy-step-card .step-text {
  color: #04535E;
  font-size: 14px;
  font-weight: 500;
}
.ai-page-body .easy-step-card .learnmore {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #2E93A1;
  font-size: 12px;
  font-weight: 600;
  transition: color 0.3s ease;
}
.ai-page-body .easy-step-card .learnmore i {
  margin-top: 10px;
  margin-left: 6px;
  cursor: pointer;
  color: #2E93A1;
  font-weight: 400;
  font-size: 12px;
  transition: transform 0.3s ease;
}
.ai-page-body .easy-step-card .learnmore:hover i {
  transform: translateX(10px);
}
.ai-page-body .testimonial-card {
  border-radius: 16px;
  background-image: url("./media/testimonial-SWVNEECG.gif");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left top;
  padding: 28px;
}
.ai-page-body .testimonial-card .feedback-box {
  width: 60%;
  margin: 0 auto;
  text-align: center;
}
.ai-page-body .testimonial-card .feedback-box .quote-size {
  font-size: 46px;
  color: rgba(46, 147, 161, 0.5019607843);
  margin-bottom: 0px;
  text-align: center;
  line-height: 0.7;
}
.ai-page-body .testimonial-card .feedback-box .feedback-text {
  color: #0C6056;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 15px;
}
.ai-page-body .testimonial-card .feedback-box .author {
  color: #484B59;
  font-size: 14px;
  margin-bottom: 0;
  text-align: center;
}
.ai-page-body .testimonial-card .feedback-box .author .userpic {
  font-size: 14px;
  color: #2E93A1;
  margin-right: 10px;
}
.btn-joinwaitlist-yellow {
  padding: 13px 38px;
  border: 1px solid #7CEFFF;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1;
  background-color: #FFE500;
  min-width: 117px;
  outline: none;
  color: #484B59;
  font-weight: 600;
  margin: 0 auto;
  display: block;
}
.btn-ai-sourcing-white {
  padding: 13px 38px;
  border: 1px solid #7CEFFF;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1;
  background-color: #FFFEF4;
  min-width: 117px;
  outline: none;
  color: #969696;
  font-weight: 600;
}
.text-speed {
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
  background:
    linear-gradient(
      90.2deg,
      #2E93A1 41.31%,
      #E24E7F 72.77%);
  color: transparent;
  background-clip: text;
  margin-bottom: 10px;
}
.text-content {
  text-align: center;
  line-height: 1.5;
  font-size: 14px;
  color: #969696;
  width: 63%;
  margin: 0 auto;
}
.empty-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.landing {
  color: transparent;
  background-clip: text;
  top: -5px !important;
  background:
    linear-gradient(
      90deg,
      #ED1EAF 0%,
      #ED1EAF 100%);
  background-clip: text;
}
.btn-joinwaitlist-yellow.disabled {
  pointer-events: none;
  background-color: #cccccc;
  border: none;
}
/*# sourceMappingURL=ai-sourcing-landingpage.component-6QI7CR2Q.css.map */
